module.exports = __webpack_public_path__ + "img/紫菀.6626879f.jpg";